module.exports = __webpack_public_path__ + "static/Положение_о_депутатском_расследовании.doc";